import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroBanner from './components/HeroBanner';
import PolicyContent from './components/PolicyContent';

const PrivacyPolicyPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <HeroBanner />
      <PolicyContent />
      <Footer />
    </div>
  );
};

export default PrivacyPolicyPage;